export default __webpack_public_path__ + "static/media/contactsOrange.714cc104.svg";